<script lang="ts">
import { defineComponent } from 'vue';
import {
  any, func, object, string,
} from 'vue-types';
import { Button } from 'ant-design-vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Any = any;

export default defineComponent({
  name: 'TableEvent',
  components: {
    Button,
  },
  props: {
    value: any(),
    record: object(),
    getLink: func<(data: Any) => string>(),
    onClick: func<(data: Any) => void>(),
    class: any(),
    dataTestId: string(),
  },
});
</script>

<template>
  <NuxtLink
    v-if="getLink"
    :to="getLink(record)"
    :class="[$props.class, 'whitespace-normal']"
    :data-test-id="dataTestId"
  >
    <slot>
      {{ value }}
    </slot>
  </NuxtLink>
  <Button
    v-else-if="onClick"
    :class="[$props.class, 'whitespace-normal']"
    type="link"
    html-type="button"
    :data-test-id="dataTestId"
    @click="() => onClick && onClick(record)"
  >
    <slot>
      {{ value }}
    </slot>
  </Button>
  <span v-else :class="[$props.class, 'whitespace-normal']" :data-test-id="dataTestId">
    <slot>
      {{ value }}
    </slot>
  </span>
</template>
